import React from 'react';
import { LayoutGrid, Ruler, Percent } from 'lucide-react';

/**
 * Компонент секции параметров укладки плитки
 */
const InstallationParametersSection = ({ formData, handleInputChange, errors, layoutPatterns }) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <LayoutGrid className="w-5 h-5 mr-2 text-fuchsia-500" />
        Параметры укладки
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Тип укладки */}
        <div>
          <label htmlFor="layoutPattern" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Способ укладки
          </label>
          <select
            id="layoutPattern"
            name="layoutPattern"
            value={formData.layoutPattern}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {layoutPatterns.map((pattern) => (
              <option key={pattern.id} value={pattern.id}>
                {pattern.name}
              </option>
            ))}
          </select>
        </div>

        {/* Ширина шва */}
        <div>
          <label htmlFor="seamWidth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Ruler className="w-4 h-4 mr-2 text-fuchsia-500" />
            Ширина шва (мм)
          </label>
          <input
            type="text"
            id="seamWidth"
            name="seamWidth"
            value={formData.seamWidth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.seamWidth ? 'input-error' : ''}`}
            placeholder="Ширина шва"
          />
          {errors.seamWidth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.seamWidth}
            </p>
          )}
        </div>

        {/* Запас на подрезку и брак */}
        <div>
          <label htmlFor="wasteFactor" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Percent className="w-4 h-4 mr-2 text-fuchsia-500" />
            Запас на брак и подрезку (%)
          </label>
          <input
            type="text"
            id="wasteFactor"
            name="wasteFactor"
            value={formData.wasteFactor}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.wasteFactor ? 'input-error' : ''}`}
            placeholder="Запас в процентах"
          />
          {errors.wasteFactor && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.wasteFactor}
            </p>
          )}
        </div>
      </div>

      {/* Подсказки по укладке */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div className="bg-white dark:bg-gray-800 rounded-lg p-3 border border-gray-200 dark:border-gray-700">
          <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">Оптимальный запас материала</h4>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            {formData.layoutPattern === 'straight' && 'Для прямой укладки рекомендуется запас 10%'}
            {formData.layoutPattern === 'diagonal' && 'Для диагональной укладки рекомендуется запас 15-20%'}
            {formData.layoutPattern === 'herringbone' && 'Для укладки "ёлочкой" рекомендуется запас 15-20%'}
            {formData.layoutPattern === 'brick' && 'Для кирпичной кладки рекомендуется запас 12-15%'}
          </p>
        </div>
        
        <div className="bg-white dark:bg-gray-800 rounded-lg p-3 border border-gray-200 dark:border-gray-700">
          <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">Ширина шва</h4>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            {formData.tileType === 'ceramic' && 'Для керамической плитки рекомендуется шов 2-3 мм'}
            {formData.tileType === 'porcelain' && 'Для керамогранита рекомендуется шов 2-4 мм'}
            {formData.tileType === 'natural_stone' && 'Для натурального камня рекомендуется шов 3-5 мм'}
            {formData.tileType === 'mosaic' && 'Для мозаики шов обычно в пределах 1-2 мм'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstallationParametersSection;